<template>
  <div>
    <gj-alert
        border
        show-icon>
      <div style="line-height: 20px;">1、为防止店铺关联，<span style="color: red;">请选择区域、站点后，复制授权链接到安全环境下授权</span></div>
      <div style="line-height: 20px;">2、在安全环境授权成功后，请复制验证码回到系统，输入验证码进行验证；验证通过后即授权成功</div>
      <div style="line-height: 20px;">3、授权成功后，您可以在其他任何地方登录积加ERP查看店铺数据</div>
    </gj-alert>

    <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        style="margin: 20px 0;"
        label-width="150px"
        class="form">

      <el-form-item label="店铺名称" prop="marketName">
        <gj-input v-model="ruleForm.marketName" width="400px" placeholder="请输入店铺名称"
                  :disabled="disabled"></gj-input>
      </el-form-item>

      <el-form-item label="区域" style="margin-bottom: 0;">
        <gj-select v-model="form.areaId" :options="areaOption" :clearable="false" @input="areaInput" width="400px"
                   :disabled="disabled||afresh"></gj-select>
      </el-form-item>

      <el-form-item :show-message="false" class="country-checkbox">

        <!--        重新授权-->
        <el-checkbox-group v-model="form.countryCodes" v-if="marketItem" style="width: 400px" :disabled="loading">
          <template v-if="form.areaId==='na'||form.areaId==='eu'">
            <template v-for="(item) in marketItem.items">
              <el-checkbox :key="item.countryCode" :label="item.countryCode">
                {{ countryMap[item.countryCode] ? countryMap[item.countryCode].text : '-' }}
              </el-checkbox>
            </template>
          </template>
        </el-checkbox-group>

        <!--        新店铺授权-->
        <gj-checkbox-group v-model="form.countryCodes" style="width: 450px;" :disabled="disabled||loading" v-else>
          <el-row>
            <el-col v-for="item in countryOption" :key="item.id" :span="6">
              <gj-checkbox :label="item.id" :key="item.id">
                {{ item.text }}
              </gj-checkbox>
            </el-col>
          </el-row>
        </gj-checkbox-group>

      </el-form-item>

      <el-form-item label="授权链接" style="margin-top: 5px;">
        <gj-input v-model="url" width="312px" placeholder="请稍等或选择国家" disabled></gj-input>
        <gj-button style="margin-left: 8px;" v-copy="url" :disabled="disabled" :loading="cantGetUrl">{{cantGetUrl?'生成中':'复制链接'}}</gj-button>
      </el-form-item>

      <el-form-item label="验证码" prop="code">
        <gj-input v-model="ruleForm.code" width="312px" placeholder="请输入" :disabled="disabled||loading"></gj-input>
        <gj-button style="width: 80px;margin-left: 8px;" @click="verification('ruleForm')" :disabled="!ruleForm.code||disabled" :loading="loading">验证
        </gj-button>
      </el-form-item>

      <div class="status-box">
        <div class="status-success" v-if="pass==='success'">授权成功</div>
        <div class="status-fail" v-if="pass==='fail'">{{ failMsg }}</div>
      </div>

      <!--      <el-form-item v-if="false" label="是否北美联合账号" prop="areaId"-->
      <!--                    :rules="[{ required: true, message: '请选择是否北美联合账号', trigger: ['blur', 'change'] }]">-->
      <!--        <el-radio-group-->
      <!--            v-model="form.unionAccount">-->
      <!--          <el-radio v-for="item in unionAccountOption" :key="item.id" :label="item.id">-->
      <!--            {{ item.text }}-->
      <!--          </el-radio>-->
      <!--        </el-radio-group>-->
      <!--      </el-form-item>-->

    </el-form>

  </div>
</template>

<script>
import {MarketEnum} from "../enum";
import {isMeaningless, transformToMap} from "@/utils/common";
import {
  // 获取验证地址
  getMarketAuthUrl,
  // 验证店铺授权
  spAuthInfo,
  // 保存店铺授权
  marketApiAuth,
  myCancel
} from "@/api/system";
import {amazonCountryOption} from "@/utils/options";
import {isMeaninglessMixin, responseMixin} from "@/minxins";

export default {
  name: "store-authorization",
  mixins: [isMeaninglessMixin,responseMixin],
  data() {
    return {
      //是否禁用所有button和input
      disabled: false,
      loading:false,

      cantGetUrl:false,

      countryMap: transformToMap(amazonCountryOption),

      //验证状态
      pass: 'none',
      failMsg: '',
      authInfo: '',

      areaOption: MarketEnum.areaOption,
      //区域国家列表
      countryOption: [],
      //授权链接
      url: '',
      //form表单
      ruleForm: {
        marketName: this.form.marketName,
        code: ''
      },
      //form验证
      rules: {
        marketName: [{required: true, message: '请输入店铺名称', trigger: ['blur']}],
        code: [{required: true, message: '请输入验证码', trigger: ['blur']}]
      }
    }
  },
  props: {
    form: {
      type: Object,
      default: function () {
        return {
          marketName: '',
          areaId: 'na',
          countryCodes: [],
          unionAccount: true,
          marketIds:[]
        }
      }
    },
    unionAccountOption: {
      type: Array,
      default: function () {
        return [
          {id: true, text: '是'},
          {id: false, text: '否'},
        ]
      }
    },
    marketItem: null,
    afresh:null
  },
  created() {
    this.areaInput(this.form.areaId);
  },
  watch: {
    'form.countryCodes': {
      handler: function (n, o) {
        this.getUrl();
        this.ruleForm.code = '';
        this.pass = 'none';
        this.$emit('passChange', this.pass);
      },
      immediate:true
    }
  },
  methods: {
    //根据区域设置国家列表
    areaInput(areaId) {
      if(this.afresh){
        return
      }
      const map = transformToMap(this.areaOption);
      this.countryOption = map[areaId].countryOption;
      this.form.countryCodes = [];
      let areaList = ['IN', 'AE', 'SA', 'SG', 'AU', 'JP']
      areaList.includes(areaId) && (this.form.countryCodes = [areaId])
    },

    //获取授权链接
    getUrl() {
      if (isMeaningless(this.form.countryCodes) || this.form.countryCodes.length === 0) {
        this.url = '';
        if (typeof myCancel === 'function') {
          // 取消请求
          myCancel()
        }
        this.cantGetUrl = false;
        return;
      }
      this.cantGetUrl = true;
      let param = {
        region: this.form.areaId,
        countryCodes: this.form.countryCodes,
        fromZtClient: true
      }
      getMarketAuthUrl(param).then((authUrl) => {
        this.url = authUrl;
        this.cantGetUrl = false;
      })
    },

    //验证handle
    verification(formName) {
      if (this.form.countryCodes.length > 0) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading=true;
            spAuthInfo(`?publicToken=${this.ruleForm.code}&sellingName=${this.ruleForm.marketName}`).then(data => {
              if (data.data) {
                this.authInfo = data.data;
                this.pass = 'success';
              } else {
                this.failMsg = data.msg;
                this.pass = 'fail';
              }
              // this.pass = 'success';
              // this.authInfo = {
              //   id: '1',
              //   mwsAuthToken: '1',
              //   publicToken: '1',
              //   refreshToken: '1',
              //   sellingName: '1',
              //   sellingPartnerId: '1',
              //   spAuthToken: '1',
              //   state: '1'
              // };
              this.$emit('passChange', this.pass);
              this.$emit('storePassed', this.form.areaId);
            }).complete(()=>{this.loading = false;})
          } else {
            return false;
          }
        });
      } else {
        this.$gjMessage.warning('请先选择国家')
      }
    },

    saveMarket(fn,fn2) {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.form.marketName = this.ruleForm.marketName;
          let arr1 = this._.cloneDeep(this.form.countryCodes).sort().join('');
          let arr2 = this.authInfo.state.split(',').sort().join('');
          if (arr1 !== arr2) {
            this.$gjMessage.warning('请用最新授权链接获取验证码')
            if(fn2){
              fn2()
            }
            return
          }
          let param = {
            mws_auth_token: this.authInfo.mwsAuthToken,
            spapi_oauth_code: this.authInfo.spAuthToken,
            selling_partner_id: this.authInfo.sellingPartnerId,
            publicToken: this.authInfo.publicToken,
            refreshToken: this.authInfo.refreshToken,
            name:this.form.marketName,
            state: `state=region:${this.form.areaId}|countryCodes:${this.form.countryCodes.join(',')}`
          }
          marketApiAuth(param).then((res) => {
            this.$gjResponseHandle(res, () => {
              //禁用所有按钮
              this.disabled = true;
              let data={
                region: this.form.areaId,//区域编码
                countryCode: this.form.countryCodes,
                marketId: res[0].marketId,
                marketName: this.form.marketName,//店铺名称
                sellerId:this.authInfo.sellingPartnerId,
                items:res.map(r=>{
                  return{
                    countryCode:r.countryCode,
                    email: null,
                    id: r.marketId
                  }
                })
              }
              if(fn){
                fn(data);
              }
            });
          }).complete(() => {
            if(fn2){
              fn2()
            }
          })
        } else {
          if(fn2){
            fn2()
          }
          return false;
        }
      })

    }
  }
}
</script>

<style scoped lang="scss">

.status-box {
  height: 30px;
  padding-left: 150px;
}
</style>


